import { DataGrid, theme, Avatar, AvatarSize, IconDictionary, TableCell } from '@ketch-com/deck'
import { Box, Typography } from '@mui/material'
import { useDataSentryContext } from 'pages/dataSentry/context/DataSentryContext'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium'
import { SearchTextInput } from 'components/searchTextInput/SearchTextInput'
import { useState, useEffect } from 'react'

export const Found: React.FC = () => {
  const { networkDetails } = useDataSentryContext()
  const [searchText, setSearchText] = useState('')
  const [filteredRows, setFilteredRows] = useState<string[]>(networkDetails?.urlsSeen ?? [])

  useEffect(() => {
    const rows = networkDetails?.urlsSeen ?? []
    const filtered = rows.filter(url => String(url).toLowerCase().includes(searchText.toLowerCase()))
    setFilteredRows(filtered)
  }, [networkDetails, searchText])

  const handleSearch = (value: string) => {
    setSearchText(value)
  }

  const columns: GridColDef<string[]>[] = [
    {
      align: 'left',
      field: 'urlsSeen',
      headerName: 'URL of the Page Where Found',
      flex: 3,
      headerAlign: 'left',
      sortable: false,
      renderCell: ({ row }: GridRenderCellParams<string[]>) => {
        return (
          <TableCell>
            <Box display="flex" alignItems="center" gap={1} maxWidth="100%">
              <Avatar
                icon={IconDictionary.OGlobe}
                textColor={theme.palette.Text.Secondary}
                variant="square"
                backgroundColor={theme.palette.Black.o8}
                size={AvatarSize.medium}
                sx={{ borderRadius: 1.5 }}
              />
              <Typography
                component="div"
                variant="label"
                sx={{
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  maxWidth: '100%',
                }}
              >
                {row}
              </Typography>
            </Box>
          </TableCell>
        )
      },
    },
  ]

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="body">Below are all URLs where this network request was found.</Typography>
      <SearchTextInput
        onChange={nextValue => handleSearch(nextValue)}
        value={searchText}
        showClearButton
        minWidth="176px"
        sx={{
          width: '176px',
          '& .MuiInputBase-input': { maxWidth: '112px', minWidth: '112px' },
        }}
      />
      <Box height="55vh">
        <DataGrid
          sx={{
            '& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeaderCheckbox):hover': {
              backgroundImage: 'unset',
              cursor: 'auto',
            },
          }}
          autosizeOnMount
          autosizeOptions={{
            expand: true,
            includeHeaders: true,
            includeOutliers: false,
          }}
          getRowHeight={() => 'auto'}
          columns={columns}
          getRowId={row => row}
          rows={filteredRows}
          checkboxSelection={false}
          hideFooter
          disableRowSelectionOnClick
          disableColumnMenu
          disableColumnPinning
          disableColumnReorder
          disableColumnResize
          disableChildrenSorting={false}
          disableRowHoverStates
          noRowsOverlayProps={{ buttonTitle: '' }}
        />
      </Box>
    </Box>
  )
}
